const links = [
  {
    text: "Svelte developer page - https://svelte.dev/",
    link: "https://svelte.dev/",
  },
  {
    text: "Svelte homepage - http://sveltejs.com/",
    link: "http://sveltejs.com/",
  },
  {
    text: "Sapper homepage - https://sapper.svelte.dev/",
    link: "https://sapper.svelte.dev/",
  },
  {
    text: "Lifecycle hooks",
    link: "https://reactgo.com/svelte-lifecycle-hooks-tutorial/",
  },
  {
    text: "More on lifecycle hooks",
    link: "https://flaviocopes.com/svelte-lifecycle-events/",
  },
  {
    text:
        "CSS tricks article about Svelte - https://css-tricks.com/what-i-like-about-writing-styles-with-svelte/",
    link:
        "https://css-tricks.com/what-i-like-about-writing-styles-with-svelte/",
  },
  {
    text:
        "Flavio Copes homepage (a guy who writes about Svelte a lot) - https://flaviocopes.com/",
    link: "https://flaviocopes.com/",
  },
  {
    text: "A benchmark article of modern web frameworks",
    link:
        "https://medium.com/free-code-camp/a-realworld-comparison-of-front-end-frameworks-with-benchmarks-2019-update-4be0d3c78075",
  },
  {
    text: "Vanilla JS - http://vanilla-js.com/",
    link: "http://vanilla-js.com/",
  },
  {
    text: "Bundlephobia - https://bundlephobia.com/",
    link: "https://bundlephobia.com/",
  },
];

export default links;
